export default function Maintenance() {
   return (
      <section className="min-h-screen bg-[#141414] text-white flex flex-col items-center justify-center px-6 py-12 text-center">
         <img src="/images/fff-logo.png" alt="Forward Flow" width="180" className="mb-12" />
         <div className="w-full max-w-lg">
            <p className="text-sm text-gray-400 mb-4">TEMPORARILY UNAVAILABLE</p>
            <h1 className="text-3xl font-semibold mb-5">We're undergoing maintenance</h1>
            <p className="text-base leading-7 text-gray-300">
               Forward Flow is temporarily unavailable while we work on our systems.
               Please check back later. Thank you for your patience.
            </p>
            <a href="/signin" className="inline-block mt-8 text-sm text-white underline underline-offset-4">
               Return to sign in
            </a>
         </div>
      </section>
   )
}
